import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n"; // Inicializar i18n

// Interceptar fetch globalmente para adicionar header do ngrok
const originalFetch = window.fetch;
window.fetch = function (url, options = {}) {
  const { headers = {}, ...restOptions } = options;

  // Adicionar header para pular página de aviso do ngrok
  const mergedHeaders = {
    "ngrok-skip-browser-warning": "true",
    ...headers,
  };

  /* Renovação silenciosa do JWT grava o token novo só no localStorage (evita loop
   * de re-renders em useEffect([token])). Requisições devem usar sempre o Bearer atual. */
  try {
    const stored = localStorage.getItem("ikaro_auth_token");
    if (
      stored &&
      mergedHeaders.Authorization &&
      String(mergedHeaders.Authorization).toLowerCase().startsWith("bearer ")
    ) {
      mergedHeaders.Authorization = `Bearer ${stored}`;
    }
  } catch {
    /* ignore */
  }

  const hadAuthHeader =
    !!mergedHeaders?.Authorization &&
    String(mergedHeaders.Authorization).toLowerCase().startsWith("bearer ");

  return originalFetch(url, {
    ...restOptions,
    headers: mergedHeaders,
  }).then((response) => {
    try {
      const renewed = response.headers?.get?.("X-Renewed-Token");
      if (renewed && typeof window.__IKARO_AUTH_UPDATE_TOKEN__ === "function") {
        window.__IKARO_AUTH_UPDATE_TOKEN__(renewed);
      }

      if (
        hadAuthHeader &&
        response.status === 401 &&
        typeof window.__IKARO_AUTH_LOGOUT__ === "function"
      ) {
        window.__IKARO_AUTH_LOGOUT__();
      }
    } catch {
      // ignora falhas de leitura de headers / hooks
    }
    return response;
  });
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
